import React, { useEffect } from "react";
import { Paper } from "@material-ui/core";

import styled from "styled-components";
import { StyledHeader } from "../../../styles";

import { Doughnut } from "react-chartjs-2";
import Grid from "@material-ui/core/Grid";

const StyledPaper = styled(Paper)`
    width: 100%;
    border: 1px solid blue;
`;

const UserAnalytics = (props) => {
    useEffect(() => {}, []);
    return (
        <StyledPaper
            style={{ borderWidth: "0.5px", borderColor: "#0188cc" }}
            justify="center"
            alignItems="center"
        >
            <StyledHeader
                style={{
                    height: "fit-content",
                    width: "100%",
                    backgroundColor: "#0188cc",
                    color: "white",
                }}
            >
                {" "}
                User Analytics{" "}
            </StyledHeader>

            <div>
                <Grid container spacing={3} style={{ margin: 12 }}>
                    <Grid item xs={6}>
                        <div
                            style={{
                                width: "70%",
                                height: "70%",
                            }}
                        >
                            <Doughnut
                                data={props.userJobpacks.map1}
                                height={50}
                                width={50}
                                options={{
                                    title: {
                                        display: true,
                                        text: "Total Count ",
                                        fontSize: 15,
                                        responsive: true,
                                        maintainAspectRatio: false,
                                    },
                                    legend: {
                                        display: true,
                                        position: "top",
                                    },
                                }}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={6}>
                        <div
                            style={{
                                width: "70%",
                                height: "70%",
                            }}
                        >
                            <Doughnut
                                data={props.userJobpacks.map2}
                                height={50}
                                width={50}
                                options={{
                                    title: {
                                        display: true,
                                        text: "Inspection Items",
                                        fontSize: 15,
                                        responsive: true,
                                        maintainAspectRatio: false,
                                    },
                                    legend: {
                                        display: true,
                                        position: "top",
                                    },
                                }}
                            />
                        </div>
                    </Grid>
                </Grid>
            </div>
        </StyledPaper>
    );
};
export default UserAnalytics;
